export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/SN-48ac6a05075c614ccbb83964758598b0.png";